import {Injectable} from '@angular/core';
import {HttpClientWrapperService} from '../config/http-client-wrapper.service';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class IndividualAccidentsService {

  constructor(private http: HttpClientWrapperService, private authService: AuthService) {
  }

  ageCheck(birthday: string) {
    return this.http.get(`individual-accidents/statistics/ageCheck/${birthday}`);
  }

  getOffers(companyID: number) {
    return this.http.get(`individual-accidents/statistics/offers?companyID=${companyID ? companyID : ''}`);
  }

  createRequest(backEndInformation: any) {
    return this.http.post('individual-accidents/insurance/create', backEndInformation, this.authService.decode().auth);
  }

  downloadNewInsurance(requestID: number) {
    return this.http.get('individual-accidents/file-management/released-insurance-file?mode=directLink&requestID='
      + requestID, this.authService.decode().auth);
  }

  getRequestInfo(requestID: number) {
    return this.http.get(`individual-accidents/statistics/details?requestID=${requestID}`, this.authService.decode().auth);
  }
}
